import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

// For debugging
const DEBUG = true;

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => {
  if (DEBUG) {
    console.log('Progress component rendering with value:', value);
  }
  
  return (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-primary transition-transform duration-300 ease-in-out"
      style={{
        transform: `translateX(-${100 - (value || 0)}%)`,
        willChange: 'transform'
      }}
    />
  </ProgressPrimitive.Root>
);
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
